import React, { Component } from "react";

import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";
import { withMainContext } from "../../hoc/withMainContext";

class BankImportFormatSelect extends Component {
  render() {
    
    const strLibelle = this.props.intl.formatMessage({ id: "ids_libelle" });
    const strAmount  = this.props.intl.formatMessage({ id: "ids_amount" });

    const importFormats = [
        {id: "IMPORT_BANKOFAMERICA", label:"Bank Of America"},
        {id: "IMPORT_BASIC_DDMMYYYY", label:"Basic JJMMAAAA", help: "JJ/MM/AAAA ; " + strLibelle + " ; " + strAmount},
        {id: "IMPORT_BASIC_MMDDYYYY", label:"Basic MMDDYYYY", help: "MM/DD/YYYY ; " + strLibelle + " ; " + strAmount},
      ];

    let options = [];
    let value = this.props.value;
    if (importFormats) {
      options = importFormats.map(format => {
        return { label: format.label, value: format.id, help: format.help};
      });
    }

    console.log("FormatSelect", value);
    return (
      <SimpleSelect
        name="importFormat"
        value={value}
        onSelected={this.props.onSelected}
        options={options}
        clearable={false}
        disabled={this.props.disabled}
      />
    );
  }
}

export default withMainContext(BankImportFormatSelect);
